'use strict';

var StrategyReadonlyClosureDirective = function StrategyReadonlyClosureDirective() {
  return {
    restrict: 'E',
    replace: true,
    require: '^rmStrategyReadonly',
    template: require('../templates/strategy-readonly-closure.html')
  };
};
StrategyReadonlyClosureDirective.$inject = [];
module.exports = StrategyReadonlyClosureDirective;